

export function handleAsyncCalls(asynFunctions) {
  return new Promise((resolve, reject) => {
    var successValues = [];
    var errors = [];

    asynFunctions && asynFunctions.forEach(func => {
      func()
        .then(val => {
          successValues.push(val);
          if(successValues.length === asynFunctions.length) {
            return resolve(successValues);
          }
          else if((successValues.length  + errors.length) === asynFunctions.length) {
            return reject({successValues, errors});
          }
        })
        .catch(err => {
          errors.push(err);
          if((successValues.length  + errors.length) === asynFunctions.length) {
            return reject({successValues, errors});
          }
        });
    });
  });
};



// WEBPACK FOOTER //
// src/common/async-operation-utilities.js